import axios from 'axios';
import Country from '@/domain/countries/entity/country.entity';

export default class CountryService {
  public static findCountries(): Promise<Country[]> {
    return axios.get('/api/countries')
      .then(({ data }: any) => data.map(it => new Country(it)));
  }
}
